import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface BrowseByContentCardEntityParams {
  content_class: string;
  content_value_id: number;
  content_value_name: string;
  forward_state_name: string;
  forward_state_params: any;
  image_asset_type: string;
  image_asset_url: string;
  layout_position: string;
}
export class BrowseByContentCardEntity extends BaseEntityClass {
  content_class: string;
  content_value_id: number;
  content_value_name: string;
  forward_state_name: string;
  forward_state_params: any;
  image_asset_type: string;
  image_asset_url: string;
  layout_position: string;
  constructor(params: BrowseByContentCardEntityParams) {
    super();
    this.type = "popular_categories_content_card"; // this is the legacy entity type, kept for reporting ease
    this.entity_version = 2;
    this.content_class = params.content_class;
    this.content_value_id = params.content_value_id;
    this.content_value_name = params.content_value_name;
    this.forward_state_name = params.forward_state_name;
    this.forward_state_params = params.forward_state_params;
    this.image_asset_type = params.image_asset_type;
    this.image_asset_url = params.image_asset_url;
    this.layout_position = params.layout_position;
  }
}
